import { SWAGGER_URL } from '@/utils/constants';

export const API_PREFIX = SWAGGER_URL.replace(
  /https:\/\/api-?(website-)?/,
  '',
).replace(/\.remuno\.com.+/, '');

export const DOCS_BASE_DOMAIN = API_PREFIX
  ? `docs-${API_PREFIX}.remuno.com`
  : 'docs.remuno.com';

export const WIDGET_SOURCE_BASE_DOMAIN = API_PREFIX
  ? `pay-${API_PREFIX}.remuno.com`
  : 'pay.remuno.com';

export const capitalize = (str: string): string => {
  return str
    .split(' ')
    .map(
      (currStr) =>
        currStr.substring(0, 1).toUpperCase() +
        currStr.substring(1).toLowerCase(),
    )
    .join(' ');
};
